type SummaryEmptyStateProps = {
  message: string;
};

/*
displays empty state message when ai insights are not available
*/
const SummaryEmptyState = ({ message }: SummaryEmptyStateProps) => (
  <div className="metadoc-viewer-workspace__summary-empty">{message}</div>
);

export default SummaryEmptyState;
